import User from 'react-feather/dist/icons/user.js'
import './UserIcon.scss'

export default function UserIcon() {
  return (<User className="user-icon" />)
}
